import React from 'react';
import styled from 'styled-components';
import { useAppVersion } from '../utils/useAppVersion';

const FooterContainer = styled.footer`
  background: ${({ $auth }) => (
    $auth
      ? 'linear-gradient(to bottom right, #f1f5f9, #eff6ff, #f1f5f9)'
      : '#0f172a'
  )};
  color: ${({ $auth }) => ($auth ? '#111827' : 'white')};
  padding: 2rem;
  text-align: center;
  border-top: none;
`;

function Footer({ auth = false }) {
  const currentYear = new Date().getFullYear();
  const version = useAppVersion();
  return (
    <FooterContainer $auth={auth}>
      <p>&copy; {currentYear} ОНЛАНТА ИИ ХАБ. Все права защищены. Версия: {version}</p>
    </FooterContainer>
  );
}

export default Footer; 